

// Function to show wishlist notifications
function showWishlistNotification(message) {
    let notification = document.getElementById('wishlist-notification');
    
    // If notification element does not exist, create it
    if (!notification) {
        notification = document.createElement('div');
        notification.id = 'wishlist-notification';
        document.body.appendChild(notification);
    }

    notification.innerText = message;
    // notification.style.display = 'block';
    notification.classList.add("active");
    
    // Hide the notification after 3 seconds
    setTimeout(() => {
        // notification.style.display = 'none';
        notification.classList.remove("active");
    }, 3000);
}






// Function to toggle the wishlist (add/remove product)
function toggleWishlist(button) {
    const pdpData = {
        productTitle: button.getAttribute('data-product-title'),
        productImg: button.getAttribute('data-product-img'),
        productPrice: button.getAttribute('data-product-price'),
        productUrl: button.getAttribute('data-product-url'),
        productHandle: button.getAttribute('data-product-handle')
    };
//   console.log(pdpData)
    let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
    // console.log("Initial wishlist data:", wishlistData);
    const isAlreadyInWishlist = wishlistData.some(item => item.productTitle === pdpData.productTitle);

    if (!isAlreadyInWishlist) {
        wishlistData.push(pdpData);
        localStorage.setItem('wishlist', JSON.stringify(wishlistData));
        // console.log("Item added:", pdpData);
        button.innerHTML = getWishlistButtonHtml(true);
        showWishlistNotification(`${pdpData.productTitle} added to wishlist`);
    } else {
        wishlistData = wishlistData.filter(item => item.productTitle !== pdpData.productTitle);
        localStorage.setItem('wishlist', JSON.stringify(wishlistData));
        // console.log("Item removed:", pdpData);
        button.innerHTML = getWishlistButtonHtml(false);
        showWishlistNotification(`${pdpData.productTitle} removed from wishlist`);
    }

    // console.log("Updated wishlist data:", wishlistData);
    displayWishlist();
}

// Function to generate wishlist button HTML
function getWishlistButtonHtml(isInWishlist) {
    if (isInWishlist) {
        return `
            <svg class="heart-filled" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="15" fill="#F5F5F5"/>
                <path d="M14.5498 10.0011L15 10.4333L15.4502 10.0011L16.144 9.33484C16.1442 9.33465 16.1444 9.33446 16.1446 9.33427C16.9348 8.57864 18.0101 8.15 19.1362 8.15C20.2622 8.15 21.3373 8.57855 22.1275 9.33403C22.9137 10.0928 23.35 11.114 23.35 12.1726C23.35 13.2314 22.9135 14.2527 22.127 15.0116C22.1268 15.0118 22.1266 15.012 22.1264 15.0122L15.0065 21.8484L15.006 21.849C15.006 21.849 15.0059 21.849 15.0059 21.849C15.0048 21.8495 15.0027 21.85 15 21.85C14.9973 21.85 14.9952 21.8495 14.994 21.849L14.9935 21.8484L7.87358 15.0122C7.87342 15.012 7.87326 15.0119 7.8731 15.0117C7.0865 14.2529 6.65 13.2315 6.65 12.1726C6.65 11.1139 7.08632 10.0928 7.87261 9.33394C8.66278 8.57852 9.73786 8.15 10.8638 8.15C11.99 8.15 13.0653 8.57869 13.8555 9.33442C13.8557 9.33456 13.8558 9.3347 13.856 9.33484L14.5498 10.0011Z" stroke="black" stroke-width="1.3"/>
            </svg>
            <p class="wishlist_text"></p>
        `;
    } else {
        return `
            <svg class="heart-outline" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="15" fill="#F5F5F5"/>
                <path d="M14.5498 10.0011L15 10.4333L15.4502 10.0011L16.144 9.33484C16.1442 9.33465 16.1444 9.33446 16.1446 9.33427C16.9348 8.57864 18.0101 8.15 19.1362 8.15C20.2622 8.15 21.3373 8.57855 22.1275 9.33403C22.9137 10.0928 23.35 11.114 23.35 12.1726C23.35 13.2314 22.9135 14.2527 22.127 15.0116C22.1268 15.0118 22.1266 15.012 22.1264 15.0122L15.0065 21.8484L15.006 21.849C15.006 21.849 15.0059 21.849 15.0059 21.849C15.0048 21.8495 15.0027 21.85 15 21.85C14.9973 21.85 14.9952 21.8495 14.994 21.849L14.9935 21.8484L7.87358 15.0122C7.87342 15.012 7.87326 15.0119 7.8731 15.0117C7.0865 14.2529 6.65 13.2315 6.65 12.1726C6.65 11.1139 7.08632 10.0928 7.87261 9.33394C8.66278 8.57852 9.73786 8.15 10.8638 8.15C11.99 8.15 13.0653 8.57869 13.8555 9.33442C13.8557 9.33456 13.8558 9.3347 13.856 9.33484L14.5498 10.0011Z" stroke="black" stroke-width="1.3"/>
            </svg>
            <p class="wishlist_text"></p>
        `;
    }
}

// Function to display the wishlist items
function displayWishlist() {
    const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
    // console.log("Display wishlist data:", wishlistData);
    if (wishlistData.length === 0) {
        console.log('Wishlist is empty');
        const wishlistBlock = document.querySelector('.js-wishlistBlock');
        if (wishlistBlock) {
            wishlistBlock.innerHTML = '<p>No items in your wishlist.</p>';
        }
        return;
    }

    const wishlistHtml = wishlistData.map(item => {
        // Log the current item being mapped
        // console.log("Mapping item:", item);
        
        return `
            <div class="wishlist-product__list" data-product-title="${item.productTitle}">
                <div class="c-product">
                    <span class="remove_from_wishlist">X</span>
                    <a href="${item.productUrl}">
                        <img src="${item.productImg}" alt="${item.productTitle}">
                    </a>
                    <h3 class="c-product__title card__heading h5">
                        <a class="full-unstyled-link" href="${item.productUrl}">${item.productTitle}</a>
                    </h3>
                    <p>${item.productPrice}</p>
                    <button class="wishlist-quick-view quick-view-modal open-quick-view" data-handle="${item.productHandle}">Add to cart
                <div class="loading__spinner hidden">
  <svg
    aria-hidden="true"
    focusable="false"
    class="spinner"
    viewBox="0 0 66 66"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
                </button>
                </div>
                
            </div>
        `;
    }).join('');


    const wishlistBlock = document.querySelector('.js-wishlistBlock');
    if (wishlistBlock) {
        wishlistBlock.innerHTML = wishlistHtml;
    } else {
        console.error('Element with class "js-wishlistBlock" not found');
    }
}

// Event listener for DOM content load
document.addEventListener('DOMContentLoaded', function () {
    // Find all wishlist buttons
    const wishlistButtons = document.querySelectorAll('.wishlist_button');

    wishlistButtons.forEach(button => {
        // Initialize button based on whether product is in wishlist
        const productTitle = button.getAttribute('data-product-title');
        const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
        const isAlreadyInWishlist = wishlistData.some(item => item.productTitle === productTitle);

        button.innerHTML = getWishlistButtonHtml(isAlreadyInWishlist);

        // Attach event listener to the button
        button.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent page reload
            toggleWishlist(this); // Call the toggleWishlist function to add/remove the product
        });
    });

    // Display wishlist items
    displayWishlist(); // Update the wishlist display based on the current stored data
});


setInterval(function() {
    // Retrieve the 'wishlist' from localStorage
    let wishlist = localStorage.getItem('wishlist');
  
    // Parse the JSON string to a JavaScript array
    wishlist = wishlist ? JSON.parse(wishlist) : [];
  
    // Get the length of the wishlist array
    let wishlistLength = wishlist.length;
  
    // Select all elements with class 'wishlist_count' and update their text content
    document.querySelectorAll('.wishlist_count').forEach(function(element) {
        element.textContent = wishlistLength;
    });
}, 1000);






// Event listener for DOM content load
document.addEventListener('DOMContentLoaded', function () {

// Function to handle removing a product from wishlist
function removeFromWishlist(productTitle) {
    // Retrieve the 'wishlist' from localStorage
    let wishlist = localStorage.getItem('wishlist');
    
    if (wishlist) {
        wishlist = JSON.parse(wishlist);
        
        // Find the index of the product with matching productTitle
        const index = wishlist.findIndex(product => product.productTitle === productTitle);

        // If a match is found, remove that product from the wishlist array
        if (index !== -1) {
            wishlist.splice(index, 1); // Remove the matched product
        }

        // Update localStorage with the new wishlist
        localStorage.setItem('wishlist', JSON.stringify(wishlist));

        // Update the wishlist count in the DOM
        document.querySelector('.wishlist_count').textContent = wishlist.length;

        // Optionally, remove the product's DOM element from the page
        document.querySelector(`[data-product-title="${productTitle}"]`).remove();
    }
}

// Attach click event listener to .remove_from_wishlist spans
document.querySelectorAll('.remove_from_wishlist').forEach(button => {
    button.addEventListener('click', function() {
        // Get the parent .wishlist-product__list div's 'data-product-title' attribute
        const productTitle = this.closest('.wishlist-product__list').getAttribute('data-product-title');
        
        // Remove the product from the wishlist
        removeFromWishlist(productTitle);
    });
});

});
